import { render, staticRenderFns } from "./BTableCard.vue?vue&type=template&id=26439388&scoped=true"
import script from "./BTableCard.vue?vue&type=script&lang=js"
export * from "./BTableCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26439388",
  null
  
)

export default component.exports